<script setup lang="ts">
import { ref } from "vue";
import { useEventBus } from "@vueuse/core";
import { useAppStore } from "@/ts/stores/app";

const appStore = useAppStore();
const bus = useEventBus<string>("hamburger");

interface Props {
    openActive?: boolean;
    dark: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    openActive: false,
});

let active = ref(props.openActive);

bus.on((event: string) => {
    switch (event) {
        case "hamburger-close":
            active.value = false;
            break;
        case "hamburger-open":
            active.value = true;
            break;
    }
});

function toggleMenu() {
    if (active.value) {
        bus.emit("hamburger-close");
    } else {
        bus.emit("hamburger-open");
    }

    appStore.navigation.slideout.visible = !appStore.navigation.slideout.visible;
}
</script>

<template>
    <div class="hamburger-wrapper" @click="toggleMenu">
        <div class="hamburger-button" :class="{ active: active }">
            <span :class="appStore.navigation.slideout.visible ? 'bg-white' : appStore.navigation.header.sticky || dark ? 'bg-primary' : 'bg-white'"></span>
            <span :class="appStore.navigation.slideout.visible ? 'bg-white' : appStore.navigation.header.sticky || dark ? 'bg-primary' : 'bg-white'"></span>
            <span :class="appStore.navigation.slideout.visible ? 'bg-white' : appStore.navigation.header.sticky || dark ? 'bg-primary' : 'bg-white'"></span>
        </div>
    </div>
</template>

<style lang="scss">
.hamburger-wrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
}

.hamburger-button {
    width: 32px;
    height: 60px;
    padding: 20px 12px 20px 8px;
    overflow: hidden;
    flex-flow: column;
    justify-content: space-between;
    //margin: auto 16px auto 0;
    transition: height 0.2s;
    z-index: 200;
    display: flex;

    span {
        height: 3px;
        width: 27px;
        border-radius: 1px;
        display: flex;
        transition: all 0.2s;
        transform-origin: left;
        align-self: flex-start;
    }

    &.active {
        span {
            &:nth-child(1) {
                transform: rotate(45deg);
            }
            &:nth-child(2) {
                opacity: 0;
            }
            &:nth-child(3) {
                transform: translateY(2px) rotate(-45deg);
            }
        }
    }
}
</style>
